export async function fileDownload(data, filename, mime, bom) {
  var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data];
  var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    await setTimeout(function() {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 200);
  }
}

export function getDate(d, type = 'datetime', separatorDate = '/', separatorMin = ':') {
  var date = new Date(d);

  if (type === 'date') {
    d = d.split('-');
    date.setMonth(+d[1] - 1);
    date.setDate(d[2]);
    date.setFullYear(d[0]);
  }

  function addZero(n) {
    return parseInt(n) > 9 ? '' + n : '0' + n;
  }

  let minutes = [date.getHours(), date.getMinutes()].join(separatorMin);

  if (window.vm.$i18n.locale.toUpperCase().trim() === 'PT_BR') {
    return `${[
      addZero(date.getDate()),
      addZero(date.getMonth() + 1),
      date.getFullYear()
    ].join(separatorDate)} ${type === 'datetime' ? addZero(minutes) : ''}`;
  }

  return `${[
    addZero(date.getMonth() + 1),
    addZero(date.getDate()),
    date.getFullYear()
  ].join(separatorDate)} ${type === 'datetime' ? addZero(minutes) : ''}`;
}

export function debounce(callback, wait) {
  let timeout;
  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
}



// WEBPACK FOOTER //
// ./src/js/base/Utils.js